var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKeresChartGroup(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 677,
    height: 189,
    viewBox: "0 0 677 189",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 31.5749L42.7731 65.1749L52.7191 57.8249L65.3173 65.1749L73.2741 91.4248L85.8723 74.6249L105.764 57.8249L119.026 65.1749L150.19 74.6249L160.799 91.4248L196.604 101.4L203.235 115.05L212.518 112.425L226.442 116.1L235.725 109.275L266.889 111.9L276.172 129.225L299.379 135L309.325 147.6H322.586L341.815 135H353.087L365.023 117.15L376.295 158.625L388.23 156L397.513 165.975L418.068 130.275L430.666 126.075L452.547 102.45L462.493 53.6249L482.385 73.5749L504.266 67.2749L514.212 41.0249L527.473 58.3499L547.365 25.2749L579.193 16.3499L591.791 20.5499L611.02 0.599854L622.955 25.2749L641.521 47.8499L653.456 67.2749L655.445 77.2499L676 88.7998",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "square"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_840_3782)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 31.4354L42.6396 65.2077L52.8669 57.8659L65.2857 65.2077L73.3214 92.1276L85.7403 74.9967L106.195 57.8659L117.883 65.2077L150.026 74.9967L160.984 92.1276L196.049 101.427L203.354 115.132L212.851 112.195L226.731 116.111L236.227 109.258L266.909 112.195L276.406 129.326L299.052 134.71L309.279 147.925H322.429L342.153 134.71H353.11L364.799 117.09L376.487 158.693L388.175 155.757L397.672 166.035L418.127 130.305L429.815 126.389L452.461 102.896L462.688 52.9713L481.682 73.0389L503.597 67.6549L513.825 40.735L526.974 57.8659L546.698 25.562L578.841 16.2624L591.99 20.6674L610.984 0.599854L622.672 25.562L640.935 48.0768L653.354 67.6549L655.546 76.9546L676 89.1909V188.55H353.11H1V62.7604V31.4354Z",
    fill: "url(#paint0_linear_840_3782)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_840_3782",
    x: -49,
    y: -49.4001,
    width: 775,
    height: 287.95,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_840_3782"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_840_3782",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_840_3782",
    x1: 339.166,
    y1: 57.8249,
    x2: 338.752,
    y2: 188.551,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B4B4B",
    stopOpacity: 0.44
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCFAFF",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeresChartGroup);
export default __webpack_public_path__ + "static/media/KeresChartGroup.67633a41150cca667beb738e8c29d2e0.svg";
export { ForwardRef as ReactComponent };